import { saveAs } from 'file-saver';
import {
  canonicalLabel,
  COLLECTION_IMPORT_FIELDS,
  templateDataFields,
} from './import-schema';

const TEMPLATE_FILENAME = 'πρότυπο-εισαγωγής-συλλογών.xlsx';

/** Δημιουργεί και κατεβάζει το πρότυπο Excel εισαγωγής */
export async function downloadCollectionImportTemplate(): Promise<void> {
  const Excel = await import('exceljs');
  const wb = new Excel.Workbook();
  wb.creator = 'WasteMgmt';
  wb.created = new Date();

  const dataSheet = wb.addWorksheet('Δεδομένα', {
    views: [{ state: 'frozen', ySplit: 1 }],
  });

  const dataFields = templateDataFields();
  dataSheet.columns = dataFields.map((def) => ({
    header: canonicalLabel(def),
    key: def.field,
    width: Math.max(canonicalLabel(def).length + 4, 16),
  }));

  const headerRow = dataSheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

  // Γραμμή παραδείγματος
  const exampleRow: Record<string, string | number> = {};
  for (const def of dataFields) {
    exampleRow[def.field] = def.example ?? '';
  }
  dataSheet.addRow(exampleRow);
  dataSheet.getRow(2).font = { color: { argb: 'FF6C757D' }, italic: true };

  const helpSheet = wb.addWorksheet('Οδηγίες');
  helpSheet.columns = [
    { header: 'Στήλη', key: 'column', width: 24 },
    { header: 'Εναλλακτική Ονομασία Στήλης', key: 'columnAlt', width: 28 },
    { header: 'Υποχρεωτικό', key: 'required', width: 14 },
    { header: 'Περιγραφή', key: 'description', width: 48 },
    { header: 'Παράδειγμα', key: 'example', width: 20 },
    { header: 'Σημειώσεις', key: 'notes', width: 36 },
  ];

  const helpHeader = helpSheet.getRow(1);
  helpHeader.font = { bold: true };
  helpHeader.alignment = { wrapText: true, vertical: 'top' };

  for (const def of COLLECTION_IMPORT_FIELDS) {
    const requiredText =
      def.field === 'code' || def.field === 'code_01' || def.field === 'code_02'
        ? 'Όχι*'
        : def.required
          ? 'Ναι'
          : 'Όχι';
    helpSheet.addRow({
      column: canonicalLabel(def),
      columnAlt: def.labels.slice(1).join(', '),
      required: requiredText,
      description: def.description,
      example: def.example ?? '',
      notes: def.notes ?? '',
    });
  }

  helpSheet.addRow({});
  helpSheet.addRow({
    column: '',
    columnAlt: '',
    required: '',
    description:
      '* Ο κωδικός εντύπου: είτε μία στήλη «Κωδικός Εντύπου» είτε δύο στήλες «Σειρά Παραστατικού» + «Αριθμ. Παραστατικού».',
    example: '',
    notes: '',
  });

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, TEMPLATE_FILENAME);
}
